<template>
  <div id="app" :class="vueAppClasses">
    <!-- recompilar -->
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

const contentIdleClass = "supplier-content user-content";
const contentOpenBarClass = "supplier-content user-content open-user-bar-content";
export default {
  name: 'app-supplier',
  components: {
  },
  data () {
    return {
      vueAppClasses: [],
      defaultTitle: "RedGirasol",
    }
  },
  watch: {
    '$store.state.theme' (val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    },
    '$route' (to, from){
      document.title = to.meta.title ? `${to.meta.title} - ${this.defaultTitle}` : this.defaultTitle;
    },
    isLogged(val){
      if(val){
        this.$store.commit('SET_THEME_FOR_USER', this.user)
        this.toggleClassInBody(this.$store.state.theme)
      }
    }
  },
  methods: {
    ...mapActions('auth', ['getUserInfo']),
    toggleMenu (state) {
      this.menuVisible = state;
    },
    toggleClassInBody (className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      }else if (className === 'rg') {
        document.body.classList.remove('theme-dark')
        document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-rg')
      }
      else if (className === 'rg-semi-dark') {
        document.body.classList.remove('theme-light')
        document.body.classList.remove('theme-dark')
        document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-rg-semi-dark')
      }
      else if (className === 'light') {
        document.body.classList.remove('theme-dark')
        document.body.classList.remove('theme-semi-dark')
        document.body.classList.remove('theme-rg-semi-dark')
        document.body.classList.add('theme-light')
      }
      else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize () {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll () {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },
  },
  computed: {
    ...mapState("auth", ["user", "isLogged"]),
    ...mapState(["loading"]),
    contentClass: function (){
      return this.menuVisible ? contentOpenBarClass : contentIdleClass;
    }
  },
  async created () {
    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)
  },
  mounted() {
    this.toggleClassInBody(this.$store.state.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    if(this.user === null) {
      this.menuVisible = false;
      this.buttonActive = false;
    } /*else {
      Echo.private('App.User.' + this.user.user_id)
        .notification((notification) => {
          console.log(notification.type);
        });
    }*/

    if(this.user){
      this.$store.commit('SET_THEME_FOR_USER', this.user)
    }

  },
  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
